import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "id", "size", "mode", "children", "label", "menuHeight", "onClear", "appearance", "placeholder", "levels", "data", "selectText", "orSelectText", "isDisabled", "isParentSelectable", "isSearchable", "isClearable"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo, forwardRef } from 'react';
import { ThemeProvider } from 'styled-components';
import cx from 'classnames';
import { prefix } from '../../tools/settings';
import { Styled } from './Cascader.styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Cascader = forwardRef(function (_ref, ref) {
  var _cx;

  var customClassName = _ref.className,
      id = _ref.id,
      size = _ref.size,
      mode = _ref.mode,
      children = _ref.children,
      label = _ref.label,
      _ref$menuHeight = _ref.menuHeight,
      menuHeight = _ref$menuHeight === void 0 ? 240 : _ref$menuHeight,
      onClear = _ref.onClear,
      _ref$appearance = _ref.appearance,
      appearance = _ref$appearance === void 0 ? 'default' : _ref$appearance,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? 'All available' : _ref$placeholder,
      _ref$levels = _ref.levels,
      levels = _ref$levels === void 0 ? [] : _ref$levels,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? [] : _ref$data,
      _ref$selectText = _ref.selectText,
      selectText = _ref$selectText === void 0 ? 'Select' : _ref$selectText,
      _ref$orSelectText = _ref.orSelectText,
      orSelectText = _ref$orSelectText === void 0 ? 'or select' : _ref$orSelectText,
      _ref$isDisabled = _ref.isDisabled,
      isDisabled = _ref$isDisabled === void 0 ? false : _ref$isDisabled,
      _ref$isParentSelectab = _ref.isParentSelectable,
      isParentSelectable = _ref$isParentSelectab === void 0 ? false : _ref$isParentSelectab,
      _ref$isSearchable = _ref.isSearchable,
      isSearchable = _ref$isSearchable === void 0 ? false : _ref$isSearchable,
      _ref$isClearable = _ref.isClearable,
      isClearable = _ref$isClearable === void 0 ? false : _ref$isClearable,
      rest = _objectWithoutProperties(_ref, _excluded);

  var className = cx((_cx = {}, _defineProperty(_cx, "".concat(prefix, "-cascader"), true), _defineProperty(_cx, customClassName, !!customClassName), _cx));
  var defaultData = useMemo(function () {
    return [{
      label: placeholder,
      value: ''
    }].concat(_toConsumableArray(data));
  }, [data, placeholder]);
  return _jsxs(ThemeProvider, {
    theme: {
      mode: mode,
      size: size
    },
    children: [_jsx(Styled.CascaderGlobalStyle, {}), _jsx(Styled.Cascader, _objectSpread({
      ref: ref,
      levels: levels,
      label: label,
      data: defaultData,
      select_text: selectText,
      orselect_text: orSelectText,
      className: className,
      searchable: isSearchable,
      cleanable: isClearable,
      preventOverflow: true,
      menuWidth: 160,
      menuHeight: menuHeight,
      renderValue: function renderValue(value, itemPaths, selectedElement) {
        return _jsx(_Fragment, {
          children: itemPaths.length > 0 ? itemPaths[itemPaths.length - 1].label : selectedElement
        });
      },
      onClean: onClear,
      disabled: isDisabled,
      parentSelectable: isParentSelectable,
      placeholder: placeholder
    }, rest))]
  });
});
Cascader.displayName = 'Cascader';
export default Cascader;